import { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { useLanguage } from "../context/LanguageContext";

export default function PvGenerationTabs({ active, reference, multiyear }) {
  const { isGreek } = useLanguage();
  const [tab, setTab] = useState(() => new URLSearchParams(window.location.search).get("analysis") === "multiyear" ? "multiyear" : "reference");
  return <>
    <Tabs value={tab} onChange={(_, next) => setTab(next)} variant="scrollable"
      scrollButtons="auto" allowScrollButtonsMobile data-no-translate
      aria-label={isGreek ? "Ανάλυση παραγωγής ΦΒ" : "PV production analysis"}
      sx={{ mb: 2, borderBottom: 1, borderColor: "divider" }}>
      <Tab value="reference" id="pv-reference-tab" aria-controls="pv-reference-panel"
        label={isGreek ? "Έτος αναφοράς" : "Reference year"} sx={{ textTransform: "none" }} />
      <Tab value="multiyear" id="pv-multiyear-tab" aria-controls="pv-multiyear-panel"
        label={isGreek ? "Πολυετής ανάλυση" : "Multi-year analysis"} sx={{ textTransform: "none" }} />
    </Tabs>
    <Box role="tabpanel" id="pv-reference-panel" aria-labelledby="pv-reference-tab" hidden={tab !== "reference"}>
      {reference(active && tab === "reference")}
    </Box>
    <Box role="tabpanel" id="pv-multiyear-panel" aria-labelledby="pv-multiyear-tab" hidden={tab !== "multiyear"}>
      {multiyear(active && tab === "multiyear")}
    </Box>
  </>;
}
